import { lazyForPaint } from 'react-loosely-lazy';
import { withAsync } from '@atlassian/help-center-common-component/with-async';

export const CompleteSignup = withAsync({
    loader: lazyForPaint(() => import(/* webpackChunkName: "complete-signup" */ './hocs')),
});
